import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useTranslation } from '../../../lib/i18n';
import { useGenericBi } from '../../../lib/use-generic-bi';
import { TASK_DETAILS_PAGE } from '../../../lib/tasks-bi';
import { Collapsible } from '../ui';
import { AgentConversationPanel } from './AgentConversationPanel';
import styles from './AgentConversationCard.module.css';

// "View Agents Conversation" — the live worker transcript behind a collapsible disclosure (design-QA
// Figma 13523-230622). No card chrome: just a hairline above the header, exactly as the design draws it,
// collapsed and expanded. Expanding grows the body — the modal's / sheet's own scroller (the drill-in's
// ONE scroll container) carries the transcript; the panel deliberately adds no scroller of its own.
//
// A dashboard-build task is the exception: it runs service-side with no agent behind it, so it names the
// section for the build and says so rather than promising a transcript that never arrives.
export function AgentConversationCard({ taskId, dashboardBuild = false }: { taskId: string; dashboardBuild?: boolean }) {
  const { t } = useTranslation();
  const { logModalActionBi } = useGenericBi('task-details');
  const [open, setOpen] = useState(false);

  const toggle = () => {
    logModalActionBi({
      ...TASK_DETAILS_PAGE,
      modal_name: 'task_detail',
      action: open ? 'collapse_agents_conversation' : 'expand_agents_conversation',
    });
    setOpen((v) => !v);
  };

  return (
    <section className={styles.section}>
      <button
        type="button"
        className={`${styles.toggle} ${open ? styles.toggleOpen : ''}`.trim()}
        aria-expanded={open}
        onClick={toggle}
      >
        <span className={styles.title}>{t(dashboardBuild ? 'tasks.detail.buildActivity' : 'tasks.detail.viewAgentsConversation')}</span>
        <ChevronDown size={20} aria-hidden className={`${styles.chevron} ${open ? styles.chevronOpen : ''}`.trim()} />
      </button>
      <Collapsible open={open}>
        <div className={styles.body}>
          <AgentConversationPanel taskId={taskId} dashboardBuild={dashboardBuild} />
        </div>
      </Collapsible>
    </section>
  );
}
